import type { AxiosError, AxiosInstance } from 'axios';
import { reportError } from '@/services/datadog/reporter';
import { scrubUrl } from '@/services/datadog/scrub';

const SERVER_ERROR = 500;
const CANCELED = 'ERR_CANCELED';
const ABSOLUTE_URL_PATTERN = /^[a-z][a-z\d+.-]*:\/\//i;

const requestUrl = ({ config }: AxiosError): string => {
  const url = config?.url ?? '';
  return ABSOLUTE_URL_PATTERN.test(url) ? url : `${config?.baseURL ?? ''}${url}`;
};

export const reportFailedRequest = (error: AxiosError): void => {
  if (error.code === CANCELED) return;
  const status = error.response?.status ?? 0;
  if (status !== 0 && status < SERVER_ERROR) return;
  const method = (error.config?.method ?? 'request').toUpperCase();
  reportError(new Error(`Request failed: ${method} ${scrubUrl(requestUrl(error))} status ${status}`));
};

const isAxiosError = (error: unknown): error is AxiosError =>
  typeof error === 'object' && error !== null && (error as AxiosError).isAxiosError === true;

export const onRejectedRequest = (error: unknown): Promise<never> => {
  if (isAxiosError(error)) reportFailedRequest(error);
  return Promise.reject(error);
};

export const trackFailedRequests = (instance: AxiosInstance): void => {
  instance.interceptors.response.use(undefined, onRejectedRequest);
};
